export const tagColorMap = {
  deal: 'bg-blue-4',
  ev: 'bg-grey-1',
  hold: 'bg-yellow-3',
  locked: 'bg-red-2',
  price: 'bg-green-2',
  reservable: 'bg-blue-2'
};
